// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"isomorphic-fetch":"76205b4a668050a5756a","core-js":"b4cbf1617a5d7513ba9d","Page/Page":"d9107cab8c5ece925971"}[chunkId] + ".js";
};